// extracted by mini-css-extract-plugin
module.exports = {"form":"EditCheckbox_form__lRJVb","input":"EditCheckbox_input__2BaSn","label":"EditCheckbox_label__GSy9r"};